import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * A command sent by the rovo client to send the final response message to the inline input box.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send the final response message to the inline input box.
 */
export const InlineInputBoxFinalResponseMessageCommand: CommandConstructor<
	CommandProperties,
	void
> = createCommand<CommandProperties, void>('inline-input-box-final-response-message-command');
